import { useEffect } from "react";
import { useFirstMountState } from "react-use";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGetMyBTArticleList } from "@routes/MyAccount/hooks/useGetMyBTArticleList";
import { GaObject } from "@routes/MyAccount/utils/types";
import useMyBtStore from "@store/useMyBtStore";

import MyAccountPopoverMyBTEmptyState from "./MyAccounMyBTPopoverEmptyState";
import MyAccounMyBTPopoverList from "./MyAccounMyBTPopoverList";

export default function MyAccounMyBTPopover(): React.ReactElement {
  const { loginId } = useUserInfo();
  const sendDataToGTM = useGTMDispatch();
  const isFirstMount = useFirstMountState();

  const userTags = useMyBtStore((store) => store.tags);
  const { myBTArticleList, isLoading } = useGetMyBTArticleList({
    tags: userTags,
    size: 2,
    tagSize: 2,
    isPopover: true,
  });

  const isEmptyState = myBTArticleList.length === 0;

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!isFirstMount) return;

    const userKeywords = userTags?.map(({ name }) => name).join("|");

    const gaObject: GaObject = {
      event: "custom_event",
      eventCategory: "mybt",
      eventAction: "visible",
      eventLabel: window.location.href,
    };

    if (userKeywords) {
      gaObject["user_keyword"] = userKeywords;
    }

    sendDataToGTM(gaObject);
  }, [userTags, sendDataToGTM, isFirstMount]);

  return (
    <div
      data-testid="my-account-more-info-read-component"
      className="w-[360px] p-6"
    >
      {!loginId || (isEmptyState && !isLoading) ? (
        <MyAccountPopoverMyBTEmptyState />
      ) : null}

      {!isEmptyState && loginId && !isLoading ? (
        <MyAccounMyBTPopoverList tagWithArticleList={myBTArticleList} />
      ) : null}

      {isLoading && loginId ? (
        <div className="text-center">
          <FontAwesomeIcon icon={faSpinner} size="2x" spin className="mb-6" />
        </div>
      ) : null}
    </div>
  );
}
